// extracted by mini-css-extract-plugin
export default {"container":"CategoryContainer_container__qObTM"};